import { FirmContext } from "../contexts/AuthContext";
import { isSuperAdmin } from "./superRoles";

export const canEditOrganizationTemplates = (
  firmContext: FirmContext | null | undefined
): boolean => {
  if (!firmContext?.permissions) return false;
  return Boolean(firmContext.permissions.organization?.edit_templates);
};

export const canCustomizeReports = (firmContext: FirmContext | null | undefined): boolean => {
  if (!firmContext) return false;
  return isSuperAdmin(firmContext) || canEditOrganizationTemplates(firmContext);
};
